var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"placement":_vm.placement,"effect":"dark"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]},proxy:true}])},[_c('img',{attrs:{"src":_vm.imgsrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }